import * as React from 'react';
import Obfuscate from 'react-obfuscate';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { ThemeProvider } from '@mui/material/styles';
import Copyright from '../components/Copyright';
import theme from '../components/theme';

function Contact() {
  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="md">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minHeight: "75vh",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'analogous.main' }}>
            {/* Insert your logo here */}
          </Avatar>
          <Typography component="h1" variant="h5">
            Contact
          </Typography>
          <Typography variant="body1" color="text.secondary" align="left">
            <Obfuscate email="contact@venturevaluations.com" />
          </Typography>
        </Box>
        <Copyright sx={{ mt: 5 }} />
      </Container>
    </ThemeProvider>
  );
}

export default Contact;